import { isServer } from 'src/utils/common';

import { DynamicObject } from '../../commonTypes';
import {
  API_ERROR,
  createCustomErrorObj,
  // getResponseBodyErrorCode,
  getKeyByValue,
  getResponseBodyErrorCode,
  storeApiIdentificationName
} from './ErrorTracker';
import { TrackErrorEventParams } from './types';

const getWindow = () => {
  if (typeof window === 'undefined') {
    return globalThis;
  } else {
    return window;
  }
};

export function trackAppVersion() {
  setCustomAttribute('releaseVersion', process.env.APP_VERSION || '');
}

const isProd = () => {
  const allowedHosts = ['zee5.com', 'www.zee5.com'];
  return (
    process.env.NODE_ENV === 'production' &&
    getWindow() &&
    getWindow().location &&
    allowedHosts.includes(getWindow().location.hostname)
  );
};

export const setCustomAttribute = (
  customProperty: string,
  customValue: string
) => {
  const obj: DynamicObject = {};
  obj[customProperty] = customValue;
  if (isProd()) {
    import('@convivainc/conviva-js-appanalytics').then((conviva) => {
      const { setCustomTags } = conviva;
      setCustomTags && setCustomTags(obj);
    });
  }
};

export function trackEvent(
  eventName: string,
  properties: DynamicObject,
  customProperty?: string,
  customValue?: string
) {
  if (customProperty && customValue) {
    setCustomAttribute(customProperty, customValue);
  }
  if (isProd()) {
    import('@convivainc/conviva-js-appanalytics').then((conviva) => {
      const { trackCustomEvent } = conviva;
      trackCustomEvent &&
        trackCustomEvent({
          name: eventName,
          data: properties
        });
    });
  }
}

export function trackErrors(error: any, info: any) {
  isProd() && console.error(error);
}

export function ctrackErrors(error: any, meta = {}) {
  isProd() && console.error(error);
}

export const trackErrorEvent = (params: TrackErrorEventParams) => {
  let errorDetails;
  let errorMessage = '';
  let errorCode = '';
  if (!params.isGql) {
    const api = getKeyByValue(params.url as string) as string;
    const responseBodyErrorCode = getResponseBodyErrorCode(params.responseData);
    // const responseBodyErrorCode = 1002;
    if (!params.responseStatus) {
      // Blocked API's/ Timeout status
      params.responseStatus = '4003';
    }

    const apiIdentificationCode = `${
      API_ERROR ? API_ERROR[api] : ''
    }-${params.requestMethod.toUpperCase()}-${
      params.responseStatus
    }-${responseBodyErrorCode}`;

    errorDetails = createCustomErrorObj({
      responseBodyErrorCode,
      apiIdentificationCode,
      api,
      requestMethod: params.requestMethod,
      requestBody: params.requestBody,
      responseData: params.responseData
    });

    if (isServer()) {
      errorMessage = params?.responseData?.errors?.[0]?.message;
      const serverErrorDetails = {
        apiIdentificationCode: errorDetails.apiIdentificationCode,
        ...(params?.responseStatus === '503' && {
          code: params?.responseData?.errors?.[0]?.code || '503',
          message: errorMessage || '################'
        })
      };
      errorCode = params?.responseData?.errors?.[0]?.code || '503';
      return serverErrorDetails;
    } else {
      storeApiIdentificationName(errorDetails.apiIdentificationCode);
    }
  } else {
    let errorBodyCustomCode = 1002; // Empty error
    if (params?.responseData) {
      errorBodyCustomCode = 1001;
      if (params.responseData?.code?.includes('MNTN')) {
        errorBodyCustomCode = params?.responseData.code;
        errorCode = params?.responseData?.code || '503';
      }
    }
    const gqlIdentificationCode = `GQL-${params?.queryCode}-${params?.responseStatus}-${errorBodyCustomCode}`;
    errorDetails = {
      gqlIdentificationCode,
      path: params.path,
      responseStatus: params.responseStatus,
      requestBody: params.requestBody,
      responseData: params.responseData
    };
  }

  if (params?.responseStatus === '503') {
    errorMessage = params?.responseData?.errors?.[0]?.message;
    // useContext(AppStoreContext).useAppStore().setGcpError({ code: errorCode, message: errorMessage });
  }

  trackEvent(params.eventName, errorDetails);
};
